import { create } from 'zustand';

const state = { status: null, title: '', description: '', duration: 0, position: 'top' };

export const useToast = create((set) => ({
  ...state,
  onOpenToast: (newState) => set((state) => ({ ...state, title: newState?.title, position: newState?.position ?? 'top', ...newState })),
  onResetToast: () => set(() => ({ ...state })),
}));
